import { downloadCSV } from "../utils/csvDownload";

interface PerProviderAdminProps {
    data: any[];
    isLoading: boolean;
}

export const PerProviderAdmin = ({
    data,
    isLoading,
}: PerProviderAdminProps) => {
    // Flatten nested quarter+provider data for CSV export
    const flattenedData =
        data?.flatMap((quarter) =>
            quarter.data.map((provider: any) => ({
                quarter: quarter.quarter,
                startDate: quarter.startDate,
                endDate: quarter.endDate,
                dataProvider: provider.dataProvider,
                dataProviderName: provider.dataProviderName,
                secondaryDataSource: provider.secondaryDataSource,
                totalEmissions: provider.totalEmissions,
                count: provider.count,
            })),
        ) || [];

    return (
        <div className="h-full flex items-center justify-center p-8">
            <button
                onClick={() =>
                    downloadCSV(flattenedData, "emissions_per_provider.csv")
                }
                disabled={isLoading || !flattenedData.length}
                className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed"
            >
                {isLoading ? "Loading..." : "Download Provider Data (CSV)"}
            </button>
        </div>
    );
};
